module.exports = __webpack_public_path__ + "static/media/zhiji1.6610ebd8.png";